module.exports = __webpack_public_path__ + "3c4b5f9a08f224c46c6ce2e1d89d46f7.svg";